module.exports = __webpack_public_path__ + "static/media/share.390d4488.svg";